<template>
  <div>
    <div class="formBox employeeBox" id="pdfDom">
      <Collapse v-model="value" simple style="border:0">
        <Panel name="1" hide-arrow style="margin-bottom: 20px;">
          <FormTitle :style="colStyle" titleText="员工个人信息" />
          <Form label-position="left" class="rowAllBox" slot="content">
            <Row class="rowAllBox">
              <Col :md="12" :xs="24" class="rowBox">
                <FormItem label="薪资期段" :label-width="labWidthLeft">
                  <Row>
                    <Col :md="name1SpanLeft" :xs="1"></Col>
                    <Col :md="10" :xs="23">
                      <Date-picker
                        type="month"
                        style="width:100%"
                        v-model="userFormItem.Period_Date"
                        format="yyyy-MM"
                      ></Date-picker>
                    </Col>
                    <Col :span="1">
                      <Button @click="search"><!-- 检索 -->{{$t('Search')}}</Button>
                    </Col>
                  </Row>
                </FormItem>
              </Col>
              <Col :md="12" :xs="24" class="rowBox">
                <FormItem label="员工工号" :label-width="labWidthLeft">
                  <Row>
                    <Col :md="name1SpanLeft" :xs="1"></Col>
                    <Col :md="name2SpanLeft" :xs="23">
                      <Input v-model="userFormItem.empCode" disabled></Input>
                    </Col>
                  </Row>
                </FormItem>
              </Col>
              <Col :md="12" :xs="24" class="rowBox">
                <FormItem label="员工姓名" :label-width="labWidthLeft">
                  <Row>
                    <Col :md="name1SpanLeft" :xs="1"></Col>
                    <Col :md="name2SpanLeft" :xs="23">
                      <Input v-model="userFormItem.userName" disabled></Input>
                    </Col>
                  </Row>
                </FormItem>
              </Col>
              <Col :md="12" :xs="24" class="rowBox">
                <FormItem label="身份证号码" :label-width="labWidthLeft">
                  <Row>
                    <Col :md="name1SpanLeft" :xs="1"></Col>
                    <Col :md="name2SpanLeft" :xs="23">
                      <Input v-model="userFormItem.id" disabled></Input>
                    </Col>
                  </Row>
                </FormItem>
              </Col>
              <!-- <Col :md="12" :xs="24" class="rowBox">
                                    <FormItem label="部门" :label-width="labWidthLeft">
                                        <Row>
                                            <Col :md="name1SpanLeft" :xs="1"></Col>
                                            <Col :md="name2SpanLeft" :xs="23">
                                                <Input v-model="userFormItem.Department" disabled></Input> -->
              <!-- <Select v-model="formItem.Department" :clearable="true" disabled>
                                                    <Option
                                                    :value="item.code"
                                                    v-for="(item, i) in aaa"
                                                    :key="i"
                                                    >{{ item.ch_value }}
                                                    </Option>
                                                </Select> -->
              <!-- </Col>
                                        </Row>
                                    </FormItem>
                                </Col> -->
              <!-- 
                                <Col :md="12" :xs="24" class="rowBox">
                                    <FormItem label="税前调整原因" :label-width="labWidthLeft">
                                        <Row>
                                            <Col :md="name1SpanLeft" :xs="1"></Col>
                                            <Col :md="name2SpanLeft" :xs="23">
                                                <Input v-model="formItem.Taxs_reason" disabled></Input>
                                            </Col>
                                        </Row>
                                    </FormItem>
                                </Col>
                            
                                <Col :md="12" :xs="24" class="rowBox">
                                    <FormItem label="税后调整原因" :label-width="labWidthLeft">
                                        <Row>
                                            <Col :md="name1SpanLeft" :xs="1"></Col>
                                            <Col :md="name2SpanLeft" :xs="23">
                                                <Input v-model="formItem.Taxe_reason" disabled></Input>
                                            </Col>
                                        </Row>
                                    </FormItem>
                                </Col>
                             -->
            </Row>
          </Form>
        </Panel>
        <Panel name="2" hide-arrow style="margin-bottom: 20px;">
          <FormTitle
            :style="colStyle"
            titleText="税前工资项目（计税方式为工资薪金税）"
          />
          <Form label-position="left" class="rowAllBox" slot="content">
            <div class="rowAllBox">
              <Row>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="基本工资" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Base_Salary"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="入离职及调薪折算"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Base_Salary_Adjustment"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="加班费" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.OT_Fee"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="请假缺勤" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Leave_Deduction"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="税前调整" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Pre_Tax_Adjustment"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <!-- <Col span="12" class="rowBox" v-if="isNew && formItem.Penalty_Deduction != 0">
                                    <FormItem label="惩罚扣除" :label-width="labWidthLeft">
                                        <Row>
                                            <Col :md="name1SpanLeft" :xs="1"></Col>
                                            <Col :md="name2SpanLeft" :xs="23">
                                                <Input v-model="formItem.Penalty_Deduction" disabled></Input>
                                            </Col>
                                        </Row>
                                    </FormItem>
                                </Col> -->
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="一次性奖励" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input v-model="formItem.Lump_Sum" disabled></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="岗位津贴" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Position_Allowance"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="技能津贴" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Skill_Allowance"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="异地住房津贴" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Relocation_Housing_Allowance"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="异地生活津贴" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Relocation_Living_Allowance"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="住房津贴" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Housing_Allowance"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="交通津贴" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Transpotation_Allowance"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="班车津贴" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Commuter_Allowance"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="其他固定津贴_NonCR"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Other_Fixed_Allowance_NonCR"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="其他固定津贴_CR" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Other_Fixed_Allowance_CR"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="岗位津贴_NonCR" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Position_Allowance_NonCR"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="交通津贴_NonCR" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Transpotation_Allowance_NonCR"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="高温津贴" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.High_Temp_Allowance"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="餐贴" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Meal_Allowance"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="轮班津贴" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Shift_Allowance"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="出差津贴" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.B_Trip_Allowance"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="其他津贴" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Other_Allowance_Total"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="佣金" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Commission"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="浮动工资" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Floating_Wages"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="月奖" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Monthly_Bonus"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="季度奖" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Quarterly_Bonus"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="半年奖" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Semi_annual_Bonus"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="第13薪" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Thirteen_Month_Salary"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="全勤奖" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Attendance_Bonus"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="签约奖" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Sign_on_Bonus"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="推荐奖" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Referral_Bonus"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="其他奖金（工资计税）"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Other_Bonus_Salary_Tax"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="其他福利及奖励" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Other_Benefits_and_Bonus"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="其他福利（仅计税）"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Other_Benefits_tax"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="税前总收入" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Total_Income"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
              </Row>
            </div>
          </Form>
        </Panel>
        <Panel name="3" hide-arrow style="margin-bottom: 20px;">
          <FormTitle :style="colStyle" titleText="年度奖金项目" />
          <Form label-position="left" class="rowAllBox" slot="content">
            <div class="rowAllBox">
              <Row>
                <!-- v-if="(isNew && (nowMonth == 3 || nowMonth == 2 || nowMonth == 1 || nowMonth == 12 || (nowMonth != 3 && nowMonth != 2 && nowMonth != 1 && nowMonth != 12 && formItem.Annual_Award != 0))) || (!isNew && (nowMonth == 3 || (nowMonth != 3 && formItem.Annual_Award != 0)))" -->
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="全年奖" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Annual_Award"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="年度考核奖" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Year_End_Performance_Award"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="其他奖金" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Other_Bonus"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="奖金合计" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input v-model="formItem.Bonus_Total" disabled></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
              </Row>
            </div>
          </Form>
        </Panel>
        <Panel name="4" hide-arrow style="margin-bottom: 20px;">
          <FormTitle :style="colStyle" titleText="公司福利明细" />
          <Form label-position="left" class="rowAllBox" slot="content">
            <div class="rowAllBox">
              <Row>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="当月商业保险（税前）"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.commercial_insurance_taxs"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="当月商业保险（税后）"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.commercial_insurance_taxe"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="累计商业保险（税前）"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.s_commercial_insurance_taxs"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="累计商业保险（税后）"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.s_commercial_insurance_taxe"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
              </Row>
            </div>
          </Form>
        </Panel>
        <Panel name="5" hide-arrow style="margin-bottom: 20px;">
          <FormTitle :style="colStyle" titleText="社保公积金福利（个人部分）" />
          <Form label-position="left" class="rowAllBox" slot="content">
            <div class="rowAllBox">
              <Row>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="养老保险" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Pension_Insurance_Deduction_emp"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="失业保险" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="
                            formItem.Unemployment_Insurance_Deduction_emp
                          "
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="大病医疗" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="
                            formItem.Major_Diease_Insurance_Deduction_emp
                          "
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="医疗保险" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Medical_Insurance_Deduction_emp"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="住房公积金" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Housing_Fund_Deduction_emp"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="社保调整值（个人部分）"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.adjust_emp"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="采暖费" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Heating_Cost_emp"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="公积金超上限缴税部分"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="
                            formItem.Housing_Fund_Taxable_Amount__Over_Tax_free_Ceiling
                          "
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="合计" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.s_adjust_emp"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
              </Row>
            </div>
          </Form>
        </Panel>
        <Panel name="6" hide-arrow style="margin-bottom: 20px;">
          <FormTitle :style="colStyle" titleText="社保公积金福利（公司部分）" />
          <Form label-position="left" class="rowAllBox" slot="content">
            <div class="rowAllBox">
              <Row>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="养老保险" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Pension_Insurance_Deduction_comp"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="医疗保险" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Medical_Insurance_Deduction_comp"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="失业保险" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="
                            formItem.Unemployment_Insurance_Deduction_comp
                          "
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="住房公积金" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Housing_Fund_Deduction_comp"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="大病医疗" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="
                            formItem.Major_Diease_Insurance_Deduction_comp
                          "
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="生育保险" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Maternity_Insurance_Deduction_comp"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="工伤保险" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Injury_Insurance_Deduction_comp"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="社保调整值（公司部分）"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.adjust_company"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="采暖费" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Heating_Cost_comp"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="独生子女费_外服发放"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="
                            formItem.The_Only_child_Allowance_paid_by_FESCO
                          "
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="合计" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.s_adjust_company"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
              </Row>
            </div>
          </Form>
        </Panel>
        <Panel name="7" hide-arrow style="margin-bottom: 20px;">
          <FormTitle :style="colStyle" titleText="税额计算" />
          <Form label-position="left" class="rowAllBox" slot="content">
            <div class="rowAllBox">
              <Row>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="累计工资税基数" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="
                            formItem.Accumulated_Tax_Base_Excluding_social_insurance
                          "
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="累计基本免税额" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Accumulated__Basic_Deduction"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="累计子女教育" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="
                            formItem.Accumulated_Statutory_Childrens_Education_Fee
                          "
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="累计继续教育" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="
                            formItem.Accumulated_Continuing_Education_Fee
                          "
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="累计住房贷款利息"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Accumulated_Housing_Loan_Interest"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="累计住房租金" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Accumulated_Housing_Rent"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="累计赡养老人" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="
                            formItem.Accumulated_Care_for_the_Elderly_Fee
                          "
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="累计大病医疗" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="
                            formItem.Accumulated_Medical_Expenses_for_serious_Illness_Fee
                          "
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="累计税延养老保险"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="
                            formItem.Accumulated_Income_Tax_Deferred_Pension_Fee
                          "
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="累计商业健康保险"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="
                            formItem.Accumulated_Commercial_health_insurance
                          "
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="累计预扣预缴税额(综合所得)"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="
                            formItem.Accumulated_Pre_deduction_Individual_Income_Salary
                          "
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="本期应预扣预缴税额(综合所得)"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="
                            formItem.Current_month_Pre_deduction_Individual_Income_Salary
                          "
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="奖金税基数" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="
                            formItem.Tax_Base_of_Year_End_Performance_Award
                          "
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="奖金税" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Tax_of_Year_End_Performance_Award"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <!-- 
                                <Col :md="12" :xs="24" class="rowBox">
                                    <FormItem label="工资税（工资+公司相关福利（公司承担））" :label-width="labWidthLeft">
                                        <Row>
                                            <Col :md="name1SpanLeft" :xs="1"></Col>
                                            <Col :md="name2SpanLeft" :xs="23">
                                                <Input v-model="formItem.spouse_national_id_number" type="number" disabled></Input>
                                            </Col>
                                        </Row>
                                    </FormItem>
                                </Col>
                                <Col :md="12" :xs="24" class="rowBox">
                                    <FormItem label="工资税基数" :label-width="labWidthLeft">
                                        <Row>
                                            <Col :md="name1SpanLeft" :xs="1"></Col>
                                            <Col :md="name2SpanLeft" :xs="23">
                                                <Input v-model="formItem.spouse_national_id_number" type="number" disabled></Input>
                                            </Col>
                                        </Row>
                                    </FormItem>
                                </Col>
                            -->
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="当月商业保险税（公司承担）"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Tax_of_Insurance_Company_Bear"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="其他税额（股票期权相关税额）"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.other_tax"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="合计" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.sum_tax"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
              </Row>
            </div>
          </Form>
        </Panel>
        <Panel name="8" hide-arrow style="margin-bottom: 20px;">
          <FormTitle :style="colStyle" titleText="税后项目（免税）" />
          <Form label-position="left" class="rowAllBox" slot="content">
            <div class="rowAllBox">
              <Row>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="税后调整" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.After_Tax_Adjustment_Total"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="配偶保费扣除" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Spouse_Premium"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="工会费扣除" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Union_Fee"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="独生子女费" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Only_child_Allowance"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="合计" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.sum_free_tax"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem label="净收入" :label-width="labWidthLeft">
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.After_Tax_Income"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
              </Row>
            </div>
          </Form>
        </Panel>
        <Panel name="9" hide-arrow style="margin-bottom: 20px;">
          <FormTitle :style="colStyle" titleText="服务留任奖金" />
          <Form label-position="left" class="rowAllBox" slot="content">
            <div class="rowAllBox">
              <Row>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="服务留任奖金税前金额"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Retension_Bonus_Gross"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="服务留任奖金税额"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Retension_Bonus_Tax"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24" class="rowBox">
                  <FormItem
                    label="服务留任奖金账户金额"
                    :label-width="labWidthLeft"
                  >
                    <Row>
                      <Col :md="name1SpanLeft" :xs="1"></Col>
                      <Col :md="name2SpanLeft" :xs="23">
                        <Input
                          v-model="formItem.Retension_Bonus_Net"
                          type="number"
                          disabled
                        ></Input>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
                <!-- <Col span="12" class="rowBox" v-if="formItem.Service_Retention_Bonus_Pre_tax != 0">
                                    <FormItem label="服务年限留任奖金计划公司计划缴纳（税前）" :label-width="labWidthLeft">
                                        <Row>
                                            <Col :md="name1SpanLeft" :xs="1"></Col>
                                            <Col :md="name2SpanLeft" :xs="23">
                                                <Input v-model="formItem.Service_Retention_Bonus_Pre_tax" type="number" disabled></Input>
                                            </Col>
                                        </Row>
                                    </FormItem>
                                </Col> -->
                <!--
                                <Col span="12" class="rowBox" v-if="formItem.Service_Retention_Bonus_After_tax != 0">
                                    <FormItem label="服务年限留任奖金计划公司实际缴纳（税后）" :label-width="labWidthLeft">
                                        <Row>
                                            <Col :md="name1SpanLeft" :xs="1"></Col>
                                            <Col :md="name2SpanLeft" :xs="23">
                                                <Input v-model="formItem.Service_Retention_Bonus_After_tax" type="number" disabled></Input>
                                            </Col>
                                        </Row>
                                    </FormItem>
                                </Col>
                                <Col span="12" class="rowBox" v-if="formItem.ax_of_Service_Retention_Bonus_Company_Afford != 0">
                                    <FormItem label="因服务年限留任奖金计划产生的个人所得税⑧" :label-width="labWidthLeft">
                                        <Row>
                                            <Col :md="name1SpanLeft" :xs="1"></Col>
                                            <Col :md="name2SpanLeft" :xs="23">
                                                <Input v-model="formItem.ax_of_Service_Retention_Bonus_Company_Afford" type="number" disabled></Input>
                                            </Col>
                                        </Row>
                                    </FormItem>
                                </Col>
                             -->
              </Row>
            </div>
          </Form>
        </Panel>
      </Collapse>
      <div style="margin-left: 16px;">
        <p>综合所得应纳税额计算方法：</p>
        <p>累计预扣预缴应纳税所得额=累计工资税基数-累计减除费用-累计专项扣除</p>
        <p>
          税额合计为本期应预扣预缴税额=【本期应预扣预缴税额(综合所得)】+【奖金税】+【其他税额】+【当月商业保险税（公司承担）】
        </p>
        <br />
        <p>净收入计算方法：</p>
        <p>
          净收入 = 税前收入额 - 社保公积金福利合计（个人部分） -
          本期应预扣预缴税额 +
          税后合计-其他福利（仅计税）+商业保险税（公司承担）
        </p>
        <br />
        <p>服务留任奖金：</p>
        <p>
          服务留任奖金每年随年终奖发放月份进行税额计算，跟随年终奖的计税方式计算税额
        </p>
        <p>相关政策可通过E-payslip中【福利管理-服务留任奖金计划】进行查询</p>
        <br />
        <p>其他项目备注：</p>
        <p>
          其他福利（仅计税）：该笔金额不从工资中发放，但需要合并计算综合所得税，全部由个人承担税
        </p>
        <p>独生子女费_外服支付：外服直接支付给员工个人，不计入员工净收入中</p>
        <p>
          累计综合所得(自然人个税申报系统)=累计工资税基数+累计商业保险（税前）
        </p>
        <!-- <p >税前调整原因：<span>{{formItem.Taxs_reason}}</span></p>
                <p >税后调整原因：<span>{{formItem.Taxe_reason}}</span></p> -->
      </div>
    </div>
    <!-- <div style="display: flex;justify-content: center;">
            <Button type="primary"  v-on:click="getPDF()">导出PDF</Button>
        </div> -->
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";

export default {
  data() {
    return {
      serialnumber: "",
      date: new DateUtil(),
      value: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      name1SpanLeft: 8,
      name2SpanLeft: 13,
      labWidthLeft: 250,
      formItem: {},
      userFormItem: {},
      aaa: [],
      nowMonth: 0,
      isNew: false,
      colStyle: ""
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.userFormItem.Period_Date =
        new Date().getUTCFullYear() + "-" + new Date().getUTCMonth();
      if (this.getQueryVariable("is_report")) {
        this.serialnumber = this.getQueryVariable("serialnumber");
      } else {
        this.serialnumber = JSON.parse(
          sessionStorage.getItem("userInfo")
        ).serialnumber;
      }
      this.getUerData();
      this.nowMonth = new Date().getUTCMonth() + 1;
    });
    this.setLabWidthLeft();
    window.onresize = () => {
      this.setLabWidthLeft();
    };
  },
  methods: {
    setLabWidthLeft() {
      let pageInnerWeight = document.documentElement.clientWidth;
      if (pageInnerWeight < 576) {
        this.labWidthLeft = 120;
      } else {
        this.labWidthLeft = 250;
      }
      console.log(this.labWidthLeft,'lab')
    },
    setStyle() {
      this.colStyle = "box-shadow:none !important";
    },
    async getPDF() {
      await this.setStyle();
      this.getPdf("薪资单");
      this.colStyle = "";
    },
    getUerData() {
      console.log(this.serialnumber);
      let obj = {
        serialnumber: this.serialnumber
      };
      axios.post("/empInfo/employeeSearch", obj).then(res => {
        if (res[0]) {
          this.$set(this.userFormItem, "empCode", res[0].empCode);
          this.$set(this.userFormItem, "userName", res[0].userName);
          this.$set(this.userFormItem, "id", res[0].id);
        }
        // this.getData()
      });
    },
    search() {
      this.getData();
    },
    getData() {
      if (this.userFormItem.Period_Date) {
        this.userFormItem.Period_Date = this.date
          .dateVal(this.userFormItem.Period_Date, "YYYY-MM-DD")
          .substring(0, 7);
        let timearr = this.userFormItem.Period_Date.replace(" ", ":")
          .replace(/\:/g, "-")
          .split("-");
        this.nowMonth = Number(timearr[1]);
      } else {
        this.$delete(this.userFormItem, "Period_Date");
      }
      let arr = {
        serialnumber: this.serialnumber,
        pageNo: 1,
        pageSize: 1000
      };

      axios.post("/EPayslip/selectEPayslip", arr).then(res => {
        this.formItem = {
          Department: "TCM_HR",
          Employee_Code: "TCM30307",
          Legal_Entity: "TCM",
          Name: "吴珏",
          Period_Date: "2020-12-31T00:00:00.000+0800",
          SBU: "CNCL4",
          ID_No: "320522197112021626",
          Accumulated_Care_for_the_Elderly_Fee: 0,
          Accumulated_Commercial_health_insurance: 0,
          Accumulated_Continuing_Education_Fee: 0,
          Accumulated_Housing_Loan_Interest: 0,
          Accumulated_Housing_Rent: 0,
          Accumulated_Income_Tax_Deferred_Pension_Fee: 0,
          Accumulated_Medical_Expenses_for_serious_Illness_Fee: 0,
          Accumulated_Pre_deduction_Individual_Income_Salary: 0,
          Accumulated_Statutory_Childrens_Education_Fee: 0,
          Accumulated_Tax_Base_Excluding_social_insurance: 0,
          Accumulated__Basic_Deduction: 0,
          After_Tax_Adjustment_Total: 0,
          After_Tax_Income: 0,
          Attendance_Bonus: 0,
          B_Trip_Allowance: 0,
          Base_Salary: 0,
          Base_Salary_Adjustment: 0,
          Commission: 0,
          Commuter_Allowance: 0,
          Current_month_Pre_deduction_Individual_Income_Salary: 0,
          Floating_Wages: 0,
          Heating_Cost_comp: 0,
          Heating_Cost_emp: 0,
          High_Temp_Allowance: 0,
          Housing_Allowance: 0,
          Housing_Fund_Deduction_comp: 0,
          Housing_Fund_Deduction_emp: 0,
          Housing_Fund_Taxable_Amount__Over_Tax_free_Ceiling: 0,
          Injury_Insurance_Deduction_comp: 0,
          Leave_Deduction: 0,
          Lump_Sum: 0,
          Major_Diease_Insurance_Deduction_comp: 0,
          Major_Diease_Insurance_Deduction_emp: 0,
          Maternity_Insurance_Deduction_comp: 0,
          Meal_Allowance: 0,
          Medical_Insurance_Deduction_comp: 0,
          Medical_Insurance_Deduction_emp: 0,
          Monthly_Bonus: 0,
          OT_Fee: 0,
          Only_child_Allowance: 0,
          Other_Allowance_Total: 0,
          Other_Benefits_and_Bonus: 0,
          Other_Benefits_tax: 0,
          Other_Bonus_Salary_Tax: 0,
          Other_Fixed_Allowance_CR: 0,
          Other_Fixed_Allowance_NonCR: 0,
          Pension_Insurance_Deduction_comp: 0,
          Pension_Insurance_Deduction_emp: 0,
          Position_Allowance: 0,
          Position_Allowance_NonCR: 0,
          Pre_Tax_Adjustment: 0,
          Quarterly_Bonus: 0,
          Referral_Bonus: 0,
          Relocation_Housing_Allowance: 0,
          Relocation_Living_Allowance: 0,
          Retension_Bonus_Gross: 0,
          Retension_Bonus_Net: 0,
          Retension_Bonus_Tax: 0,
          Semi_annual_Bonus: 0,
          Service_Retention_Bonus_After_tax: 0,
          Service_Retention_Bonus_Pre_tax: 0,
          Shift_Allowance: 0,
          Sign_on_Bonus: 0,
          Skill_Allowance: 0,
          Spouse_Premium: 0,
          Tax_Base_of_Year_End_Performance_Award: 0,
          Tax_of_Insurance_Company_Bear: 0,
          Tax_of_Year_End_Performance_Award: 0,
          Taxe_reason: "",
          Taxs_reason: "",
          The_Only_child_Allowance_paid_by_FESCO: 0,
          Thirteen_Month_Salary: 0,
          Total_Income: 0,
          Transpotation_Allowance: 0,
          Transpotation_Allowance_NonCR: 0,
          Unemployment_Insurance_Deduction_comp: 0,
          Unemployment_Insurance_Deduction_emp: 0,
          Union_Fee: 0,
          adjust_company: 0,
          adjust_emp: 0,
          ax_of_Service_Retention_Bonus_Company_Afford: 0,
          commercial_insurance_taxe: 0,
          commercial_insurance_taxs: 0,
          other_tax: 0,
          s_adjust_company: 0,
          s_adjust_emp: 0,
          s_commercial_insurance_taxe: 0,
          s_commercial_insurance_taxs: 0,
          sum_free_tax: 0,
          sum_tax: 0,
          Annual_Award: 0,
          Year_End_Performance_Award: 0,
          Other_Bonus: 0,
          Bonus_Total: 0
        };
        if (res) {
          this.formItem = res.data[0] || {};
        }
      });
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    }
  }
};
</script>

<style>
/* .formTitleBox {
    box-shadow:none !important
} */
.employeeBox .ivu-col {
  min-height: 10px;
}
.formBox {
  width: 97%;
  margin: auto;
  background: white;
  padding-bottom: 30px;
  border-radius: 10px;
  margin-top: 15px;
  margin-bottom: 15px;
}
.rowBox {
  line-height: 35px;
  font-size: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}
.addT {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed rgb(155, 155, 155);
  border-radius: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: 0.5s;
  color: rgb(155, 155, 155);
  background: white;
}
.addT:hover {
  border: 1px dashed #8b15f3;
  color: #8b15f3;
  box-shadow: 0 0 10px rgb(158, 158, 158);
}
.dataEmplyButton {
  /* text-align:center; */
  display: flex;
  justify-content: center;
}
.dataEmplyButtonLeft {
  margin-left: 10px;
  margin-right: 10px;
  background-color: #8b15f3;
}
.rowAllBox {
  width: 97%;
  margin: auto;
  margin-top: 15px;
}
.child2n {
  padding-left: 25px;
}
.titleDistance {
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/EPayslip.vue